// Mock data for MaLife landing page

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'How it Works', href: '#how' },
  { label: 'Contact', href: '#contact' },
];

export const stats = [
  { value: '10K+', label: 'Happy Riders' },
  { value: '500+', label: 'Verified Drivers' },
  { value: '24/7', label: 'Live Support' },
  { value: '15+', label: 'Cities Served' },
];

export const features = [
  {
    icon: 'Users',
    title: 'Community First',
    desc: 'Built with Batswana at heart. Every ride and delivery empowers local drivers and their families.',
  },
  {
    icon: 'Car',
    title: 'Local Drivers',
    desc: 'Verified, background-checked drivers who know Botswana roads inside and out.',
  },
  {
    icon: 'Wrench',
    title: 'Essential Services',
    desc: 'From roadside help to home repairs — book trusted professionals in minutes.',
  },
  {
    icon: 'HeadphonesIcon',
    title: '24/7 Support',
    desc: 'Real humans on the line, day and night. We are here whenever you need us.',
  },
];

export const services = [
  {
    icon: 'Car',
    title: 'MaRide',
    tagline: 'Safe rides across Botswana',
    desc: 'Request a ride in seconds. Track your driver in real-time and pay through the app.',
    color: 'from-sky-500/10 to-sky-500/5',
    accent: 'text-sky-500',
  },
  {
    icon: 'Package',
    title: 'MaDeliver',
    tagline: 'Send parcels anywhere',
    desc: 'Documents, groceries, gifts — same-day delivery across Gaborone and beyond.',
    color: 'from-blue-600/10 to-blue-600/5',
    accent: 'text-blue-600',
  },
  {
    icon: 'Wrench',
    title: 'MaFix',
    tagline: 'Home & auto repairs',
    desc: 'Plumbers, electricians, mechanics — vetted pros available on demand.',
    color: 'from-indigo-500/10 to-indigo-500/5',
    accent: 'text-indigo-500',
  },
  {
    icon: 'ShieldCheck',
    title: 'MaAssist',
    tagline: 'Roadside assistance',
    desc: 'Flat tyre? Battery dead? Help is one tap away, 24 hours a day.',
    color: 'from-cyan-500/10 to-cyan-500/5',
    accent: 'text-cyan-500',
  },
];

export const steps = [
  {
    num: '01',
    title: 'Download the App',
    desc: 'Get MaLife free from the App Store or Google Play in under a minute.',
  },
  {
    num: '02',
    title: 'Create Your Account',
    desc: 'Sign up with your phone number. Verify in seconds and you are set.',
  },
  {
    num: '03',
    title: 'Choose a Service',
    desc: 'Pick a ride, send a package, or book a pro — whatever life calls for.',
  },
  {
    num: '04',
    title: 'Enjoy & Repeat',
    desc: 'Rate your experience, save favourites, and unlock member perks.',
  },
];

export const testimonials = [
  {
    name: 'Kagiso Mokoena',
    role: 'Gaborone',
    quote: 'MaLife has made getting around the city so much easier. The drivers are always friendly and on time.',
    rating: 5,
  },
  {
    name: 'Naledi Tebogo',
    role: 'Francistown',
    quote: 'I use MaDeliver every week for my small business. Reliable, fast, and my customers love it.',
    rating: 5,
  },
  {
    name: 'Thabo Seretse',
    role: 'Maun',
    quote: 'Booked a mechanic through MaFix at 9pm on a Sunday. Absolute lifesaver.',
    rating: 5,
  },
];

export const faqs = [
  {
    q: 'Is MaLife available across Botswana?',
    a: 'Yes! We currently operate in Gaborone, Francistown, Maun, Palapye, and are expanding to more towns every month.',
  },
  {
    q: 'How do I pay for services?',
    a: 'You can pay via mobile money (Orange Money, MyZaka, Smega), debit card, or cash directly to the driver.',
  },
  {
    q: 'Are drivers verified?',
    a: 'Every driver goes through background checks, vehicle inspections, and MaLife safety training before joining the platform.',
  },
  {
    q: 'Can I become a MaLife driver or service provider?',
    a: 'Absolutely. Tap "Become a Partner" in the app or contact us at info@matshelonyana.co.bw to get started.',
  },
  {
    q: 'What if something goes wrong during a trip?',
    a: 'Our 24/7 support team is one tap away inside the app. We also have an SOS button for emergencies.',
  },
];

export const contactInfo = {
  office: 'Gaborone, Botswana',
  email: 'info@matshelonyana.co.bw',
  phone: '+267 74908 354',
};

export const heroImage = 'https://images.unsplash.com/photo-1714578187208-7461b93b6aeb?w=1200&q=80';
export const skylineImage = 'https://images.unsplash.com/photo-1592199353960-70fcf38bc66e?w=1600&q=80';
export const deliveryImage = 'https://images.pexels.com/photos/13311393/pexels-photo-13311393.jpeg?w=1200&q=80';
